// @ts-check
import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
// third-part libs
import { Rnd } from "react-rnd";
// @ts-ignore
import isFunction from "lodash/isFunction";
// style

// utils
import { isEmpty } from "../../utils";

const defaultSize = {
  width: 200,
  height: 200,
};

const minMax = {
  minWidth: 200,
  minHeight: 30,
  maxWidth: 1000,
  maxHeight: 1000,
};

const defaultPosition = {
  x: 0,
  y: 0,
};
//
const rndProps = {
  default: {
    ...defaultSize,
    defaultPosition,
  },
  style: {
    // border: "solid 1px #ddd",
    overflow: "hidden",
    padding: "12px 16px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 10px 20px 0 rgba(180, 189, 207, 0.2)",
  },
};

// @ts-ignore
const DraggableWindow = (props) => {
  const { onReady, element, rndDefault, style } = props;
  const { minWidth, minHeight, maxWidth, maxHeight } = props;
  const { onResize, onDrag, onDragStop, boundingBoxClassName } = props;
  const { dragHandleClassName } = props;
  //
  // const [localSize, setLocalSize] = useState(defaultSize);
  // const [localPosition, setLocalPosition] = useState(defaultPosition);

  // React.useEffect(() => {
  //   if (rndDefault) {
  //     const { x, y, width, height } = rndDefault;
  //     setLocalSize({ width, height });
  //     setLocalPosition({ x, y });
  //   }
  // }, [rndDefault]);

  /**
   *
   * @type {import('react-rnd').RndResizeStartCallback}
   */
  const handleResizeStart = () => {};
  /**
   *
   * @type {import('react-rnd').RndResizeCallback}
   */
  const handleResize = (e, direction, ref, delta, position) => {
    if (isFunction(onResize)) {
      onResize(e, direction, ref, delta, position);
    }
  };

  /**
   *
   * @type {import('react-rnd').RndDragCallback}
   */
  const handleDragStart = (e, data) => {};

  /**
   *
   * @type {import('react-rnd').RndDragCallback}
   */
  const handleDrag = (e, data) => {
    if (isFunction(onDrag)) {
      onDrag(e, data);
    }
  };

  /**
   *
   * @type {import('react-rnd').RndDragCallback}
   */
  const handleDragStop = (e, data) => {
    if (isFunction(onDragStop)) {
      onDragStop(e, data);
    }
  };

  return (
    <Rnd
      ref={(c) => {
        if (isFunction(onReady)) {
          onReady(c);
        }
      }}
      style={{ ...rndProps.style, ...(style || {}) }}
      default={(!isEmpty(rndDefault) && rndDefault) || rndProps.default}
      // size={localSize}
      // position={localPosition}
      minWidth={minWidth || minMax.minWidth}
      minHeight={minHeight || minMax.minHeight}
      maxWidth={maxWidth || minMax.maxWidth}
      maxHeight={maxHeight || minMax.maxHeight}
      onDrag={handleDrag}
      onDragStart={handleDragStart}
      onDragStop={handleDragStop}
      onResize={handleResize}
      onResizeStart={handleResizeStart}
      bounds={boundingBoxClassName}
      dragHandleClassName={dragHandleClassName}
    >
      {element}
    </Rnd>
  );
};

DraggableWindow.propTypes = {
  /** Rnd ready callback */
  onReady: PropTypes.func,
  /** Rnd element */
  element: PropTypes.node,
  /** Rnd default */
  rndDefault: PropTypes.objectOf(PropTypes.any),
  /** style */
  style: PropTypes.objectOf(PropTypes.any),
  /** min width */
  minWidth: PropTypes.number,
  /** max width */
  maxWidth: PropTypes.number,
  /** min height */
  minHeight: PropTypes.number,
  /** max height */
  maxHeight: PropTypes.number,
  /** resize callback */
  onResize: PropTypes.func,
  /** drag callback */
  onDrag: PropTypes.func,
  /** drag stop callback */
  onDragStop: PropTypes.func,
  /** bounding box className */
  boundingBoxClassName: PropTypes.string,
  /** drag handler className */
  dragHandleClassName: PropTypes.string,
};

DraggableWindow.defaultProps = {
  onReady: () => null,
  element: null,
  rndDefault: {},
  style: {},
  minWidth: minMax.minWidth,
  maxWidth: minMax.maxWidth,
  minHeight: minMax.minHeight,
  maxHeight: minMax.maxHeight,
  onResize: () => null,
  onDrag: () => null,
  onDragStop: () => null,
  boundingBoxClassName: null,
  dragHandleClassName: undefined,
};

export default DraggableWindow;
